import * as React from 'react'
import { OverviewCard } from './overview-card'
import { Sparkle } from '@phosphor-icons/react'

export type SkillTypeFilter = 'all' | 'hard' | 'soft'

export type OverviewCardsProps = {
  counts: {
    all: number
    hard: number
    soft: number
  }
  selectedSkillType: SkillTypeFilter
  onSkillTypeClick: (type: SkillTypeFilter) => void
}

export const OverviewCards = (props: OverviewCardsProps) => {
  const { counts, selectedSkillType, onSkillTypeClick } = props

  return (
    <div className="flex gap-3 bg-gray-50 text-progression-green items-center p-3 overflow-x-auto">
      <Sparkle size={20} weight="fill" className="flex-shrink-0" />
      Quick filters
      <OverviewCard
        description="All skills"
        onClick={() => onSkillTypeClick('all')}
        selected={selectedSkillType === 'all'}
        value={counts.all}
      />
      <OverviewCard
        description="Hard skills"
        onClick={() => onSkillTypeClick('hard')}
        selected={selectedSkillType === 'hard'}
        value={counts.hard}
      />
      <OverviewCard
        description="Soft skills"
        onClick={() => onSkillTypeClick('soft')}
        selected={selectedSkillType === 'soft'}
        value={counts.soft}
      />
    </div>
  )
}
